module.exports = __webpack_public_path__ + "static/Philippe-DeRyck.944b4788.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/speakers/Philippe-DeRyck.jpg
// module id = 52
// module chunks = 29270570622601 93388336899196 248116827846889